import { s as subscribe } from "../../../../../../chunks/utils.js";
import { c as create_ssr_component, e as escape, i as each, v as validate_component } from "../../../../../../chunks/ssr.js";
import { p as page } from "../../../../../../chunks/stores.js";
import "../../../../../../chunks/api.js";
/* empty css                                                             */
import colors from "tailwindcss/colors.js";
import "../../../../../../chunks/client.js";
/* empty css                                                             */
/* empty css                                                                    */
import { P as PageLayout } from "../../../../../../chunks/PageLayout.js";
import "dayjs";
import "../../../../../../chunks/files.js";
import "dayjs/plugin/relativeTime.js";
import "dayjs/locale/de.js";
import "../../../../../../chunks/qualification.js";
import "../../../../../../chunks/generateContractPreview.js";
import "../../../../../../chunks/modal.js";
import "@tiptap/extension-link";
import "../../../../../../chunks/TipTapEditor.js";
const durationUnitRegex = /[a-zA-Z]/;
const range = (size, startAt = 0) => [...Array(size).keys()].map((i) => i + startAt);
const css = {
  code: ".wrapper.svelte-1bsg8wv{position:relative;width:var(--size);height:var(--size)}.circle.svelte-1bsg8wv{position:absolute;width:var(--size);height:var(--size);background-color:var(--color);border-radius:100%;opacity:0.6;top:0;left:0;animation-fill-mode:both;animation-name:svelte-1bsg8wv-bounce !important}.pause-animation.svelte-1bsg8wv{animation-play-state:paused}@keyframes svelte-1bsg8wv-bounce{0%,100%{transform:scale(0)}50%{transform:scale(1)}}",
  map: `{"version":3,"file":"DoubleBounce.svelte","sources":["DoubleBounce.svelte"],"sourcesContent":["<script>import { range, durationUnitRegex } from './utils';\\nexport let color = '#FF3E00';\\nexport let unit = 'px';\\nexport let duration = '2.1s';\\nexport let size = '60';\\nexport let pause = false;\\nlet durationUnit = duration.match(durationUnitRegex)?.[0] ?? 's';\\nlet durationNum = duration.replace(durationUnitRegex, '');\\n<\/script>\\n\\n<div class=\\"wrapper\\" style=\\"--size: {size}{unit}; --color: {color}\\">\\n\\t{#each range(2, 1) as version}\\n\\t\\t<div\\n\\t\\t\\tclass=\\"circle\\"\\n\\t\\t\\tclass:pause-animation={pause}\\n\\t\\t\\tstyle=\\"animation: {duration} {version === 1\\n\\t\\t\\t\\t? \`\${(+durationNum - 0.1) / 2}\${durationUnit}\`\\n\\t\\t\\t\\t: \`0s\`} infinite ease-in-out\\"\\n\\t\\t/>\\n\\t{/each}\\n</div>\\n\\n<style>\\n\\t.wrapper {\\n\\t\\tposition: relative;\\n\\t\\twidth: var(--size);\\n\\t\\theight: var(--size);\\n\\t}\\n\\t.circle {\\n\\t\\tposition: absolute;\\n\\t\\twidth: var(--size);\\n\\t\\theight: var(--size);\\n\\t\\tbackground-color: var(--color);\\n\\t\\tborder-radius: 100%;\\n\\t\\topacity: 0.6;\\n\\t\\ttop: 0;\\n\\t\\tleft: 0;\\n\\t\\tanimation-fill-mode: both;\\n\\t\\tanimation-name: bounce !important;\\n\\t}\\n\\t.pause-animation {\\n\\t\\tanimation-play-state: paused;\\n\\t}\\n\\t@keyframes bounce {\\n\\t\\t0%,\\n\\t\\t100% {\\n\\t\\t\\ttransform: scale(0);\\n\\t\\t}\\n\\t\\t50% {\\n\\t\\t\\ttransform: scale(1);\\n\\t\\t}\\n\\t}\\n</style>\\n"],"names":[],"mappings":"AAuBC,uBAAS,CACR,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,MAAM,CAAC,CAClB,MAAM,CAAE,IAAI,MAAM,CACnB,CACA,sBAAQ,CACP,QAAQ,CAAE,QAAQ,CAClB,KAAK,CAAE,IAAI,MAAM,CAAC,CAClB,MAAM,CAAE,IAAI,MAAM,CAAC,CACnB,gBAAgB,CAAE,IAAI,OAAO,CAAC,CAC9B,aAAa,CAAE,IAAI,CACnB,OAAO,CAAE,GAAG,CACZ,GAAG,CAAE,CAAC,CACN,IAAI,CAAE,CAAC,CACP,mBAAmB,CAAE,IAAI,CACzB,cAAc,CAAE,qBAAM,CAAC,UACxB,CACA,+BAAiB,CAChB,oBAAoB,CAAE,MACvB,CACA,WAAW,qBAAO,CACjB,EAAE,CACF,IAAK,CACJ,SAAS,CAAE,MAAM,CAAC,CACnB,CACA,GAAI,CACH,SAAS,CAAE,MAAM,CAAC,CACnB,CACD"}`
};
const DoubleBounce = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { color = "#FF3E00" } = $$props;
  let { unit = "px" } = $$props;
  let { duration = "2.1s" } = $$props;
  let { size = "60" } = $$props;
  let { pause = false } = $$props;
  let durationUnit = duration.match(durationUnitRegex)?.[0] ?? "s";
  let durationNum = duration.replace(durationUnitRegex, "");
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.unit === void 0 && $$bindings.unit && unit !== void 0) $$bindings.unit(unit);
  if ($$props.duration === void 0 && $$bindings.duration && duration !== void 0) $$bindings.duration(duration);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.pause === void 0 && $$bindings.pause && pause !== void 0) $$bindings.pause(pause);
  $$result.css.add(css);
  return `<div class="wrapper svelte-1bsg8wv" style="${"--size: " + escape(size, true) + escape(unit, true) + "; --color: " + escape(color, true)}">${each(range(2, 1), (version) => {
    return `<div class="${["circle svelte-1bsg8wv", pause ? "pause-animation" : ""].join(" ").trim()}" style="${"animation: " + escape(duration, true) + " " + escape(
      version === 1 ? `${(+durationNum - 0.1) / 2}${durationUnit}` : `0s`,
      true
    ) + " infinite ease-in-out"}"></div>`;
  })} </div>`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => value);
  let { areaOptions = [] } = $$props;
  let { regionOptions = [] } = $$props;
  let { statusOptions = [
    {
      name: "Neue Bewerbung",
      value: "candidate"
    },
    {
      name: "Telefontermin gebucht",
      value: "interviewee"
    },
    {
      name: "Im Bewerbungsprozess",
      value: "onboarding"
    },
    { name: "Aktiv", value: "active" },
    { name: "Inaktiv", value: "inactive" },
    {
      name: "Freigestellt",
      value: "sabbatical"
    }
  ] } = $$props;
  if ($$props.areaOptions === void 0 && $$bindings.areaOptions && areaOptions !== void 0) $$bindings.areaOptions(areaOptions);
  if ($$props.regionOptions === void 0 && $$bindings.regionOptions && regionOptions !== void 0) $$bindings.regionOptions(regionOptions);
  if ($$props.statusOptions === void 0 && $$bindings.statusOptions && statusOptions !== void 0) $$bindings.statusOptions(statusOptions);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(PageLayout, "PageLayout").$$render(
      $$result,
      {
        path: "/employee",
        pageBackgroundClass: "bg-[#f3f6fa]",
        title: " "
      },
      {},
      {
        default: () => {
          return `<div class="was-in-slot">${``}</div> ${`${validate_component(DoubleBounce, "DoubleBounce").$$render(
            $$result,
            {
              size: "60",
              color: colors.cyan["300"],
              unit: "px",
              duration: "1s"
            },
            {},
            {}
          )}`}`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
